// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qsH0y","list":"styles_list__qyVbg","actions":"styles_actions__s35W1"};